(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["course-date-calendar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[id^="CourseDates-"]');
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const monthLookup = {
      jan: 0, january: 0, feb: 1, february: 1, mar: 2, march: 2, apr: 3, april: 3,
      may: 4, jun: 5, june: 5, jul: 6, july: 6, aug: 7, august: 7,
      sep: 8, sept: 8, september: 8, oct: 9, october: 9, nov: 10, november: 10,
      dec: 11, december: 11
    };
    const monthPattern = '(Jan(?:uary)?|Feb(?:ruary)?|Mar(?:ch)?|Apr(?:il)?|May|Jun(?:e)?|Jul(?:y)?|Aug(?:ust)?|Sep(?:t(?:ember)?)?|Oct(?:ober)?|Nov(?:ember)?|Dec(?:ember)?)';

    const monthIndex = (value) => monthLookup[value.toLowerCase()];
    const dateKey = (date) => `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
    const addWeekdays = (date, count) => {
      const result = new Date(date);
      let added = 0;
      while (added < count) {
        result.setDate(result.getDate() + 1);
        if (result.getDay() !== 0 && result.getDay() !== 6) added += 1;
      }
      return result;
    };
    const inferYear = (month, explicitYear) => {
      if (explicitYear) return Number(explicitYear);
      const now = new Date();
      return month < now.getMonth() - 1 ? now.getFullYear() + 1 : now.getFullYear();
    };

    const parseDateRange = (title) => {
      const clean = title.replace(/\([^)]*\)/g, '').replace(/\s+/g, ' ').trim();
      let match = clean.match(new RegExp(`(\\d{1,2})(?:st|nd|rd|th)?\\s*[/–-]\\s*(\\d{1,2})(?:st|nd|rd|th)?\\s+${monthPattern}(?:\\s*[/–-]\\s*${monthPattern})?(?:\\s+(20\\d{2}))?`, 'i'));
      if (match) {
        const startMonth = monthIndex(match[3]);
        const endMonth = match[4] ? monthIndex(match[4]) : startMonth;
        const startYear = inferYear(startMonth, match[5]);
        const endYear = endMonth < startMonth ? startYear + 1 : startYear;
        return { start: new Date(startYear, startMonth, Number(match[1]), 12), end: new Date(endYear, endMonth, Number(match[2]), 12) };
      }

      match = clean.match(new RegExp(`(\\d{1,2})(?:st|nd|rd|th)?\\s+${monthPattern}\\s*[/–-]\\s*(\\d{1,2})(?:st|nd|rd|th)?\\s+${monthPattern}(?:\\s+(20\\d{2}))?`, 'i'));
      if (match) {
        const startMonth = monthIndex(match[2]);
        const endMonth = monthIndex(match[4]);
        const startYear = inferYear(startMonth, match[5]);
        const endYear = endMonth < startMonth ? startYear + 1 : startYear;
        return { start: new Date(startYear, startMonth, Number(match[1]), 12), end: new Date(endYear, endMonth, Number(match[3]), 12) };
      }

      match = clean.match(new RegExp(`(\\d{1,2})(?:st|nd|rd|th)?\\s+${monthPattern}(?:\\s+(20\\d{2}))?`, 'i'));
      if (!match) return null;
      const month = monthIndex(match[2]);
      const year = inferYear(month, match[3]);
      const date = new Date(year, month, Number(match[1]), 12);
      return { start: date, end: date };
    };

    const formatDateRange = (event) => {
      const first = event.start.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
      if (dateKey(event.start) === dateKey(event.end)) return first;
      const second = event.end.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
      return `${first} – ${second}`;
    };

    roots.forEach((root) => {
      if (root.dataset.calendarReady === 'true') return;
      root.dataset.calendarReady = 'true';
      const dataElement = root.querySelector('[data-course-date-data]');
      const raw = JSON.parse(dataElement.textContent || '[]');
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const events = raw.map((item) => {
        const range = parseDateRange(item.variantTitle);
        if (!range) return null;
        let durationDays = 1;
        if (dateKey(range.start) === dateKey(range.end)) {
          if (/10\s*day/i.test(item.productTitle)) durationDays = 10;
          else if (/5\s*day/i.test(item.productTitle)) durationDays = 5;
          if (durationDays > 1) range.end = addWeekdays(range.start, durationDays - 1);
        }
        return { ...item, ...range, durationDays };
      }).filter(Boolean).filter((event) => event.end >= today).sort((a, b) => a.start - b.start);

      // Each booking is shown once, on its start date, with its full course range.
      const eventOccursOn = (event, date) => dateKey(event.start) === dateKey(date);

      const list = root.querySelector('[data-course-list]');
      const empty = root.querySelector('[data-course-empty]');
      const count = root.querySelector('[data-course-count]');
      const grid = root.querySelector('[data-calendar-grid]');
      const monthLabel = root.querySelector('[data-calendar-month]');
      let visibleMonth = events.length ? new Date(events[0].start.getFullYear(), events[0].start.getMonth(), 1) : new Date(today.getFullYear(), today.getMonth(), 1);

      count.textContent = `${events.length} date${events.length === 1 ? '' : 's'}`;
      empty.hidden = events.length > 0;
      events.forEach((event) => {
        const card = document.createElement('a');
        card.className = 'course-date-card';
        card.href = event.url;
        card.innerHTML = `
          <span class="course-date-card__date" aria-hidden="true">
            <span class="course-date-card__month">${event.start.toLocaleDateString('en-GB', { month: 'short' })}</span>
            <span class="course-date-card__day">${event.start.getDate()}</span>
          </span>
          <span>
            <span class="course-date-card__title">${event.productTitle}</span>
            <span class="course-date-card__variant">${formatDateRange(event)}</span>
            <span class="course-date-card__price">${event.price}</span>
          </span>
          <span class="course-date-card__status${event.available ? '' : ' course-date-card__status--sold-out'}">${event.available ? 'Places available' : 'Sold out'}</span>`;
        list.appendChild(card);
      });

      const renderCalendar = () => {
        monthLabel.textContent = `${monthNames[visibleMonth.getMonth()]} ${visibleMonth.getFullYear()}`;
        grid.innerHTML = '';
        const firstDay = new Date(visibleMonth.getFullYear(), visibleMonth.getMonth(), 1);
        const leading = (firstDay.getDay() + 6) % 7;
        const totalDays = new Date(visibleMonth.getFullYear(), visibleMonth.getMonth() + 1, 0).getDate();
        for (let index = 0; index < leading; index += 1) {
          const spacer = document.createElement('span');
          spacer.className = 'course-calendar__day course-calendar__day--empty';
          spacer.setAttribute('aria-hidden', 'true');
          grid.appendChild(spacer);
        }
        for (let day = 1; day <= totalDays; day += 1) {
          const cellDate = new Date(visibleMonth.getFullYear(), visibleMonth.getMonth(), day, 12);
          const cell = document.createElement('div');
          cell.className = 'course-calendar__day';
          cell.innerHTML = `<span class="course-calendar__day-number">${day}</span>`;
          events.filter((event) => eventOccursOn(event, cellDate)).forEach((event) => {
            const link = document.createElement('a');
            link.className = `course-calendar__event${event.available ? '' : ' course-calendar__event--sold-out'}`;
            link.href = event.url;
            link.textContent = `${event.productTitle} · ${formatDateRange(event)} · ${event.price}`;
            link.setAttribute('aria-label', `${event.productTitle}, ${formatDateRange(event)}, ${event.available ? 'places available' : 'sold out'}`);
            cell.appendChild(link);
          });
          grid.appendChild(cell);
        }
      };

      root.querySelector('[data-calendar-previous]').addEventListener('click', () => {
        visibleMonth = new Date(visibleMonth.getFullYear(), visibleMonth.getMonth() - 1, 1);
        renderCalendar();
      });
      root.querySelector('[data-calendar-next]').addEventListener('click', () => {
        visibleMonth = new Date(visibleMonth.getFullYear(), visibleMonth.getMonth() + 1, 1);
        renderCalendar();
      });
      renderCalendar();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["course-savings-plan"] && !Shopify.designMode) return;
  try {
    
(() => {
const form=document.getElementById('LspPlanPaymentForm');if(!form)return;
const type=document.getElementById('LspPlanType'),amount=document.getElementById('LspPlanAmount'),course=document.getElementById('LspPlanCourse'),courseSummary=document.getElementById('LspPlanCourseSummary'),reference=document.getElementById('LspPlanReference'),existing=document.getElementById('LspExistingPlan'),pay=document.getElementById('LspPlanPayButton'),review=document.getElementById('LspPaymentReview'),note=document.getElementById('LspPlanLookupNote'),labels=document.getElementById('LspPaymentLabels').dataset;
const currency=new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP'});
const source=document.querySelector('[data-lsp-records]'),groups=new Map(),plans=new Map();
for(const el of source?.querySelectorAll('[data-payment]')||[]){const r=el.dataset;if(!groups.has(r.reference))groups.set(r.reference,[]);groups.get(r.reference).push(r);}
for(const [ref,list] of groups){list.sort((a,b)=>Number(a.date)-Number(b.date));const first=list[0],target=Math.round(Number(first.target.replace(/[^0-9.]/g,''))*100),paid=list.reduce((s,r)=>s+Number(r.amount),0);
if(source.dataset.complete==='true'&&first.type==='Start a new plan'&&target>paid&&target>0&&(Date.now()/1000-Number(first.date))/86400<=90&&list.every(r=>r.status==='paid'&&r.cancelled!=='true'&&r.currency==='GBP'&&r.course===first.course)){plans.set(ref,{target,paid,course:first.course});const option=document.createElement('option');option.value=ref;option.textContent=first.course+' · '+ref;existing.append(option);}}
const newReference='LSP-'+crypto.randomUUID();
let state={};
function update(){
review.hidden=true;
const topup=type.value==='Top up an existing plan',plan=plans.get(existing.value);
existing.hidden=!topup;document.getElementById('LspExistingPlanField').hidden=!topup;course.disabled=topup;
let previous=0,total=0;
if(topup&&plan){reference.value=existing.value;previous=plan.paid;total=plan.target;let opt=Array.from(course.options).find(o=>o.value===plan.course);if(!opt){opt=document.createElement('option');opt.value=plan.course;opt.textContent=plan.course;course.append(opt);}course.value=plan.course;note.textContent=labels.matched;}
else if(topup){reference.value='';note.textContent=labels.noPlan;}
else{reference.value=newReference;total=Math.round(Number(course.selectedOptions[0]?.dataset.price||0)*100);note.textContent=labels.newPlan;}
const selectedCourse=course.selectedOptions[0];courseSummary.hidden=!selectedCourse?.value;courseSummary.querySelector('strong').textContent=selectedCourse?.textContent||'';
const remaining=Math.max(0,total-previous),min=Math.min(2000,remaining)/100;
amount.min=min;amount.max=remaining/100;
const validPlan=total>0&&(!topup||!!plan)&&remaining%100===0;
amount.disabled=!validPlan;pay.disabled=!validPlan;
if(Number(amount.value)<min)amount.value=min;
if(Number(amount.value)>remaining/100)amount.value=remaining/100;
const today=Math.round(Number(amount.value)*100),saved=previous+today,percent=total?Math.min(100,Math.round(saved/total*100)):0;
document.getElementById('LspPlanCoursePrice').value=currency.format(total/100);
document.getElementById('LspPlanSaved').textContent=currency.format(saved/100);
document.getElementById('LspPlanRemaining').textContent=currency.format(Math.max(0,total-saved)/100);
document.getElementById('LspPlanPercent').textContent=percent+'%';document.getElementById('LspPlanProgress').setAttribute('aria-valuenow',percent);document.getElementById('LspPlanProgressFill').style.setProperty('--lsp-plan-progress',percent+'%');
state={valid:validPlan,today,course:course.value};
}
form.addEventListener('input',update);type.addEventListener('change',update);existing.addEventListener('change',update);course.addEventListener('change',update);
for(const button of form.querySelectorAll('[data-lsp-amount]')){button.addEventListener('click',()=>{const requested=button.dataset.lspAmount==='full'?Number(amount.max):Number(button.dataset.lspAmount);const minimum=Number(amount.min),maximum=Number(amount.max);amount.value=Math.min(maximum,Math.max(minimum,requested));amount.dispatchEvent(new Event('input',{bubbles:true}));amount.focus();});}
pay.addEventListener('click',()=>{if(!form.reportValidity()||!state.valid)return;document.getElementById('LspReviewSummary').textContent=state.course+' · '+currency.format(state.today/100)+' · '+reference.value;review.hidden=false;review.scrollIntoView({behavior:'smooth',block:'nearest'});});
form.addEventListener('submit',e=>{if(review.hidden||!state.valid||!form.reportValidity()){e.preventDefault();return;}course.disabled=false;form.querySelector('button[type="submit"]').disabled=true;});
const requested=new URLSearchParams(location.search).get('plan');if(requested){type.value='Top up an existing plan';if(plans.has(requested))existing.value=requested;else{const option=document.createElement('option');option.value=requested;option.textContent=labels.noPlan;existing.append(option);existing.value=requested;}}
update();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lsp-gallery"] && !Shopify.designMode) return;
  try {
    
  function initLspGallery() {
    document.querySelectorAll('.lsp-gallery').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const dialog = gallery.querySelector('[data-gallery-dialog]');
      const dialogImage = gallery.querySelector('[data-gallery-dialog-image]');
      const dialogCaption = gallery.querySelector('[data-gallery-dialog-caption]');
      gallery.querySelectorAll('[data-gallery-filter]').forEach(filter => filter.addEventListener('click', () => {
        const value = filter.dataset.galleryFilter;
        gallery.querySelectorAll('[data-gallery-filter]').forEach(button => { button.classList.toggle('is-active', button === filter); button.setAttribute('aria-pressed', button === filter ? 'true' : 'false'); });
        gallery.querySelectorAll('[data-gallery-item]').forEach(item => { item.hidden = value !== 'all' && item.dataset.galleryItem !== value; });
      }));
      gallery.querySelectorAll('[data-gallery-open]').forEach(button => button.addEventListener('click', () => {
        dialogImage.src = button.dataset.src;
        dialogImage.alt = button.dataset.alt || '';
        dialogCaption.textContent = button.dataset.caption || '';
        dialog.showModal();
      }));
      gallery.querySelector('[data-gallery-close]')?.addEventListener('click', () => dialog.close());
      dialog?.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    });
  }
  initLspGallery();
  document.addEventListener('shopify:section:load', initLspGallery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lsp-product-details"] && !Shopify.designMode) return;
  try {
    
  function prepareProductDetails() {
    document.querySelectorAll('[data-lsp-description]').forEach(root => {
      if (root.dataset.faqCleaned) return;
      root.dataset.faqCleaned = 'true';
      const headings = Array.from(root.querySelectorAll('h1,h2,h3,h4,h5,h6'));
      const faqHeading = headings.find(heading => /frequently asked|\bfaqs?\b/i.test(heading.textContent));
      if (!faqHeading) return;
      const faqLevel = Number(faqHeading.tagName.slice(1));
      let node = faqHeading.nextElementSibling;
      faqHeading.remove();
      while (node) {
        const next = node.nextElementSibling;
        const isHeading = /^H[1-6]$/.test(node.tagName);
        const headingLevel = isHeading ? Number(node.tagName.slice(1)) : 7;
        if (isHeading && headingLevel <= faqLevel) break;
        node.remove();
        node = next;
      }
    });
  }
  prepareProductDetails();
  document.addEventListener('shopify:section:load', prepareProductDetails);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lsp-student-hub"] && !Shopify.designMode) return;
  try {
    
(() => {
const root=document.querySelector('[data-lsp-plan-list]');if(!root)return;
const data=document.querySelector('[data-lsp-records]'),labels=document.getElementById('LspPlanLabels').dataset,overview=document.querySelector('[data-lsp-plan-overview]');
const records=Array.from(data?.querySelectorAll('[data-payment]')||[],n=>n.dataset),groups=new Map();
for(const r of records){if(!groups.has(r.reference))groups.set(r.reference,[]);groups.get(r.reference).push(r);}
root.replaceChildren();if(!groups.size){const p=document.createElement('p');p.textContent=labels.empty;root.append(p);return;}
const money=new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP'});
const plans=Array.from(groups,([reference,list])=>{
list.sort((a,b)=>Number(a.date)-Number(b.date));const first=list[0],latest=Number(list.at(-1).date);
const target=Math.round(Number(first.target.replace(/[^0-9.]/g,''))*100);
const paid=list.filter(r=>r.status==='paid'&&r.cancelled!=='true').reduce((s,r)=>s+Number(r.amount),0);
const age=(Date.now()/1000-Number(first.date))/86400;
const review=data.dataset.complete!=='true'||!target||age>90||first.type!=='Start a new plan'||list.some(r=>r.currency!=='GBP'||r.cancelled==='true'||r.status!=='paid'||r.course!==first.course)||paid>target;
const percent=target?Math.min(100,Math.round(paid/target*100)):0,complete=!review&&paid>=target;
return{reference,list,first,target,paid,review,complete,percent,latest};
}).sort((a,b)=>Number(a.complete)-Number(b.complete)||Number(a.review)-Number(b.review)||b.latest-a.latest);
const primary=plans[0];
if(overview&&primary){
const state=primary.review?labels.review:primary.complete?labels.complete:labels.active;
const stateEl=overview.querySelector('[data-overview-state]');stateEl.textContent=state;stateEl.classList.toggle('is-review',primary.review);stateEl.classList.toggle('is-complete',primary.complete);
overview.querySelector('[data-overview-course]').textContent=primary.first.course||labels.unknown;
overview.querySelector('[data-overview-paid]').textContent=primary.list.some(r=>r.currency!=='GBP')?labels.unknown:money.format(primary.paid/100);
overview.querySelector('[data-overview-balance]').textContent=primary.review?labels.unknown:money.format(Math.max(0,primary.target-primary.paid)/100);
overview.querySelector('[data-overview-percent]').textContent=primary.review?labels.unknown:primary.percent+'%';
const bar=overview.querySelector('[data-overview-progress]');bar.hidden=primary.review;bar.style.setProperty('--lsp-progress',primary.percent+'%');bar.setAttribute('aria-valuenow',primary.percent);
overview.querySelector('[data-overview-note]').textContent=primary.review?labels.reviewNote:labels.activeNote;
const action=overview.querySelector('[data-overview-action]');action.textContent=primary.review?labels.contact:primary.complete?labels.dates:labels.topup;action.href=primary.review?'/pages/contact':primary.complete?'/pages/course-dates':'/pages/course-savings-plan?plan='+encodeURIComponent(primary.reference);
overview.hidden=false;
}
for(const plan of plans){
const{reference,list,first,target,paid,review,complete,percent}=plan;
const card=document.getElementById('LspPlanCard').content.cloneNode(true);
card.querySelector('[data-ref]').textContent=reference;
card.querySelector('[data-course]').textContent=first.course||labels.unknown;
const state=card.querySelector('[data-state]');state.textContent=review?labels.review:complete?labels.complete:labels.active;state.classList.toggle('is-review',review);state.classList.toggle('is-complete',complete);
card.querySelector('[data-paid]').textContent=list.some(r=>r.currency!=='GBP')?labels.unknown:money.format(paid/100);
card.querySelector('[data-balance]').textContent=review?labels.unknown:money.format(Math.max(0,target-paid)/100);
card.querySelector('[data-progress]').hidden=review;card.querySelector('[data-progress]').value=percent;
card.querySelector('[data-note]').textContent=review?labels.reviewNote:labels.activeNote;
const history=card.querySelector('[data-history]');for(const r of list){const li=document.createElement('li'),a=document.createElement('a');a.href=r.url;a.textContent=r.order+' · '+new Date(Number(r.date)*1000).toLocaleDateString('en-GB')+' · '+r.status.replaceAll('_',' ');li.append(a);history.append(li);}
const action=card.querySelector('[data-action]');action.textContent=labels.check;
if(!review&&!complete){action.href='/pages/course-savings-plan?plan='+encodeURIComponent(reference);action.textContent=labels.topup;}else if(complete){action.href='/pages/course-dates';action.textContent=labels.dates;}
root.append(card);
}
})();

  } catch(e) { console.error(e); }
})();
})();
